<template>
    <div class="main">
        <div class="query-item">
            <div class="search-l">
                <div>
                    车架号
                    <a-input class="inp ml24" placeholder="请输入" v-model:value="query.frameNum"></a-input>
                </div>
                <div class="ml30">
                    车辆编码
                    <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
                </div>
                <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
                <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
                <div></div>
            </div>
        </div>
        <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" class="mt23"
            size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
            v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'type'">
                {{ record.type === 1 ? '基本信息变更' : record.type === 2 ? '测试牌照更新' : '' }}
              </template>
                <template v-if="column.key === 'checkStatus'">
                    {{ record.checkStatus === 0 ? '待审核' : record.checkStatus === 1 ? '已审核' : '' }}
                </template>
                <template v-if="column.key === 'checkResult'">
                    {{ record.checkResult == 0 ? '不通过' : record.checkResult == 1 ? '通过' : '' }}
                </template>
                <template v-if="column.key === 'purview'">
                    <a-switch v-model:checked="record.purview" checked-children="启用" un-checked-children="禁用" />
                </template>
                <template v-else-if="column.key === 'action'">
                    <span>
                        <a v-if="record.checkStatus === 0 && store.hasPermi('car:audit')" @click="audit(record)">审核</a>
                        <a v-else @click="detail(record)">详情</a>
                    </span>
                </template>
            </template>
        </a-table>
        <auditModal :modalTitle="'审批'" :modal-width="'800px'" :isDetailStatus="true" ref="modalRef" @saveEvent=saveEvent>
            <div class="mt20 mb75">
                <div class="modal_content">
                  <div v-if="form.type===2" class="full-width-container">
                    <div class="frame-number-container">
                      <span class="frame-number-label">车架号：</span>
                      <span class="frame-number-value">{{ form.frameNum || '-' }}</span>
                    </div>
                    <div class="change_container">
                      <div class="change_column">
                        <div class="column_title">原测试牌照信息</div>
                        <div class="change_item">
                          <span class="item_label">测试牌照：</span>
                          <span class="item_value">{{ form.beforeData?.testCarNum || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照申领时间：</span>
                          <span class="item_value">{{ form.beforeData?.plateApplyDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照到期时间：</span>
                          <span class="item_value">{{ form.beforeData?.plateExpireDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照附件：</span>
                          <div class="item_value">
                            <image-uploader
                                v-if="form.beforeData?.plateAttachmentUrl"
                                :image-url="form.beforeData.plateAttachmentUrl"
                                :only-preview="true"
                                :box-width="200"
                                :box-height="120"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="change_column">
                        <div class="column_title">新测试牌照信息</div>
                        <div class="change_item">
                          <span class="item_label">测试牌照：</span>
                          <span class="item_value">{{ form.afterData?.testCarNum || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照申领时间：</span>
                          <span class="item_value">{{ form.afterData?.plateApplyDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照到期时间：</span>
                          <span class="item_value">{{ form.afterData?.plateExpireDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照附件：</span>
                          <div class="item_value">
                            <image-uploader
                                v-if="form.afterData?.plateAttachmentUrl"
                                :image-url="form.afterData.plateAttachmentUrl"
                                :only-preview="true"
                                :box-width="200"
                                :box-height="120"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="form.type===1" class="file_text">
                    <FileTextOutlined class="file_icon mr5" />{{ getFileName(form.fileUrl) }}
                  </div>
                  <a v-if="form.type===1" :href="form.fileUrl" target="_blank" class="update_btn">
                    <a style="color: #1D2129;"><i
                                class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>点击下载</a>
                  </a>
                </div>
                <div class="radio_class mt24">
                    <span style="padding-left: 14px;">审核意见</span>
                    <a-radio-group class="ml26" v-model:value="form.checkResult">
                        <a-radio :value="1">通过</a-radio>
                        <a-radio :value="0">不通过</a-radio>
                    </a-radio-group>
                </div>
                <div class="radio_class mt24 area_class">
                    专家组意见
                    <a-textarea class="area_width" v-model:value="form.causeMsg" placeholder="审核不通过时为必填" :rows="4" />
                </div>
            </div>
        </auditModal>

        <auditModal :modalTitle="'详情'" :modal-width="'800px'" :isDetailStatus="false" ref="modalDetailRef">
            <div class="mt20 mb62">
                <div class="modal_content">
                  <div v-if="form.type===2" class="full-width-container">
                    <div class="frame-number-container">
                      <span class="frame-number-label">车架号：</span>
                      <span class="frame-number-value">{{ form.frameNum || '-' }}</span>
                    </div>
                    <div class="change_container">
                      <div class="change_column">
                        <div class="column_title">原测试牌照信息</div>
                        <div class="change_item">
                          <span class="item_label">测试牌照：</span>
                          <span class="item_value">{{ form.beforeData?.testCarNum || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照申领时间：</span>
                          <span class="item_value">{{ form.beforeData?.plateApplyDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照到期时间：</span>
                          <span class="item_value">{{ form.beforeData?.plateExpireDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照附件：</span>
                          <div class="item_value">
                            <image-uploader
                                v-if="form.beforeData?.plateAttachmentUrl"
                                :image-url="form.beforeData.plateAttachmentUrl"
                                :only-preview="true"
                                :box-width="200"
                                :box-height="120"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="change_column">
                        <div class="column_title">新测试牌照信息</div>
                        <div class="change_item">
                          <span class="item_label">测试牌照：</span>
                          <span class="item_value">{{ form.afterData?.testCarNum || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照申领时间：</span>
                          <span class="item_value">{{ form.afterData?.plateApplyDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照到期时间：</span>
                          <span class="item_value">{{ form.afterData?.plateExpireDateStr || '-' }}</span>
                        </div>
                        <div class="change_item">
                          <span class="item_label">牌照附件：</span>
                          <div class="item_value">
                            <image-uploader
                                v-if="form.afterData?.plateAttachmentUrl"
                                :image-url="form.afterData.plateAttachmentUrl"
                                :only-preview="true"
                                :box-width="200"
                                :box-height="120"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="form.type===1" class="file_text">
                    <FileTextOutlined class="file_icon mr5" />{{ getFileName(form.fileUrl) }}
                  </div>
                  <a v-if="form.type===1" :href="form.fileUrl" target="_blank" class="update_btn">
                    <a style="color: #1D2129;"><i
                                class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>点击下载</a>
                  </a>
                </div>
                <div class="mt16">
                    <div class="modal_item">
                        <span class="modal_item_text1">审核意见：</span>
                        <span class="modal_item_text2">{{ form.checkResult == 0 ? '不通过' : form.checkResult == 1 ? '通过'
                        : '' }}</span>
                    </div>
                    <div class="modal_item" style="border-top: none;">
                        <span class="modal_item_text1">原因：</span>
                        <span class="modal_item_text2">{{ form.causeMsg }}</span>
                    </div>
                </div>
            </div>
        </auditModal>
    </div>
</template>
<script setup>
import { ref, onMounted, reactive, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import { selectPageList, getDetail, getAudit } from "@/api/car/audit.js";
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import moment from "moment";
import { debounce } from "lodash-es";
import Banner from "@/components/bannerTwo/index.vue";
import auditModal from '../../components/modal/index.vue'
import imageUploader from '@/components/imageUploader/index.vue'
import { message } from "ant-design-vue";
import useUserStore from "@/store/modules/user";
const store = useUserStore()
const router = useRouter();

const columns = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
    },
    {
        title: "测试牌照",
        dataIndex: "testCarNum",
        key: "testCarNum",
        // width: 150,
    },

    {
        title: "车架号",
        key: "frameNum",
        dataIndex: "frameNum",
    },
    {
      title: "变更类型",
      key: "type",
    },
    {
        title: "状态",
        key: "checkStatus",
    },
    {
        title: "审核意见",
        key: "checkResult",
    },
    {
        title: "原因",
        key: "causeMsg",
        dataIndex: "causeMsg",
    },
    {
        title: "更新时间",
        key: "updateTimeStr",
        dataIndex: "updateTimeStr",
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        width: 100,
    },
];


const form = ref({
    checkResult: 0,
    causeMsg: '',
    fileUrl: '',
    id: '',
    type: undefined,
    beforeData: {},
    afterData: {},
})



let dataSource = ref([]);
let query = reactive({
    frameNum: "",
    testCarNum: "",
});

const pagination = reactive({
    total: 0,
    size: "middle",
    defaultPageSize: 10,
    current: 1,
    pageSize: 10, //每页中显示10条数据
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
    showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
    onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
    onChange: pageChange, //点击页码事件
    showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
    pagination.current = page;

    // 获取表格数据
    getData();
}

function pageSizeChange(current, size) {
    console.log(size);
    pagination.pageSize = size;

    // 获取表格数据
    getData();
}

const search = () => {
    pagination.current = 1;
    getData();
};

const reset = () => {
    query.frameNum = "";
    query.testCarNum = "";
    pagination.current = 1;
    getData();
};

const getData = () => {
    const data = {
        pageIndex: pagination.current,
        pageSize: pagination.pageSize,
        conditionMap: { ...query },
    };
    selectPageList(data).then((res) => {
        console.log(res);
        dataSource.value = res.data.records || [];
        pagination.total = res.data.total;
    });
};

onMounted(async () => {
    getData();
});

const modalRef = ref()
const audit = (record) => {
    console.log(record);
    getDetail({ id: record.id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            form.value = res.data
            form.value.id = record.id;
        }
    })
    nextTick(() => {
        console.log(modalRef.value);
        modalRef.value.showModal()
    })

};

const getFileName = (url) => {
    if(url){
        let arr=url?.split('/');
        let file = arr[arr.length-1];
        return file
    }
}


const saveEvent = () => {
    console.log('123')
    getAudit(form.value).then(res => {
        console.log(res);
        if (res.code === 200) {
            message.success('信息变更申请审核成功')
            // 获取表格数据
            getData();
        }
    })
}

const modalDetailRef = ref()
const detail = (record) => {
    console.log(record);
    getDetail({ id: record.id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            form.value = res.data
            form.value.id = record.id;
        }
    })
    nextTick(() => {
        modalDetailRef.value.showModal()
    })
}

</script>

<style lang="less" scoped>
.inp {
    width: 13.5vw;
}

.query-item {
    display: flex;
    justify-content: space-between;

    .search-l {
        display: flex;
    }

    .search-r {
        display: flex;
    }
}

.full-width-container {
  width: 100%;
}

.frame-number-container {
  margin-bottom: 20px;
  padding: 10px 0;
  border-bottom: 1px solid #e8ebf0;
  width: 100%;  /* 确保宽度充满容器 */
  text-align: left;  /* 确保内容左对齐 */
  align-self: flex-start;  /* 覆盖父容器的居中设置 */
}

.frame-number-label {
  font-weight: 500;
  color: #636d7b;
  margin-right: 8px;
}

.frame-number-value {
  color: #1d2129;
}

.modal_content {
    // width: 516px;
    // height: 154px;
    background: rgba(246, 248, 250, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    min-height: 200px;  // 添加最小高度确保内容可见
    width: 100%;  // 确保宽度充满容器
    
    .change_container {
        display: flex;
        width: 100%;
        justify-content: space-around;
    }

    .change_column {
        width: 45%;
    }

    .column_title {
        font-size: 14px;
        font-weight: 500;
        color: #636d7b;
        margin-bottom: 16px;
        padding-bottom: 8px;
        border-bottom: 1px solid #E1E7EF;
    }

    .change_item {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
    }

    .item_label {
        width: 100px;
        color: #636D7B;
        text-align: right;
        margin-right: 12px;
    }

    .item_value {
        color: #1D2129;
        flex: 1;
    }

    .file_text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1D2129;
        padding-top: 24px;

        .file_icon {
            color: rgba(24, 111, 242, 1);
        }

    }

    .update_btn {
        cursor: pointer;
        padding: 3px 0;
        width: 100px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #636D7B;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #636D7B;
        margin-top: 34px;
        text-align: center;
    }
}

.radio_class {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 1);
}

.area_class {
    display: flex;
}

.area_width {
    width: 620px;
    margin-left: 26px;
}

.modal_item {
    // height: 48px;
    border: 1px solid #E1E7EF;
    padding: 17px 0 11px 28px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
}

.modal_item_text1 {
    color: rgba(99, 109, 123, 1);
    display: inline-block;
    width: 70px;
    text-align: right;
}

.modal_item_text2 {
    color: rgba(29, 33, 41, 1);
}

/deep/.ant-input::placeholder {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #68767e;
}

/deep/.ant-select-selector {
    background-color: #f2f4f7 !important;
    color: #68767e !important;
}

.main {
    padding: 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(10, 33, 46, 1);
    background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
    color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    width: 0px;
}

/deep/.ant-radio-wrapper {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #143652;
    margin-right: 54px;
}

/deep/.ant-radio-wrapper span.ant-radio+* {
    margin-left: 20px;
}

a {
    color: #1E8EF2;
}

.mt24 {
    margin-top: 24px;
}

.ml26 {
    margin-left: 26px;
}

.mb75 {
    margin-bottom: 75px;
}

.mb62 {
    margin-bottom: 62px;
}
</style>